//{id:'子应用唯一id',url:'子应用的地址',name:'子应用名称，用于框架启动',alias:'应用别名，用于展示在应用列表'}
let srcList = []
import { uuid } from '../../utils/tools'
export default () => {
    return new Promise((res, rej) => {
        let that = null;
        class ViewContainer extends HTMLElement {
            src = "about:blank"
            state = {}
            uuid = uuid()

            showScrollBar = true;

            appName = '';
            loaded = false;
            iframeDOMContentLoaded = false;
            // 等候发送的消息列队
            msgQueuing = [];
            set origins(val) {
                this.Application.proc.data.origins = val;
            }

            get origins() {
                return this.Application.proc.data.origins || []
            }
            constructor() {
                self = super()
                that = this;
                this.Application = globalThis.$Core.getProvider('Application');

                setTimeout(() => {
                    if (this.Application.installed) {
                        this.init()
                    } else {
                        // 未安装完成，等待安装完成
                        this.Application.on('application.installed', () => {
                            this.init()
                        })
                    }
                }, 0)

                this.onload = () => {
                    this.Application.emit('application.frame.loaded')
                }
                window.addEventListener('message', this.message)
            }

            // 接收信息
            message(event) {
                var origin = event.origin
                if (!that.checkedOrigin(origin)) return;
                let data = event.data;
                console.log(data)
                if(data.loaded){
                    that.iframeDOMContentLoaded = true;
                }
                let messageList = that.Application.proc.data.message || new Map()
                messageList.set(data.name, data.data)
                that.Application.proc.data.message = messageList;
                that.messageCallback && that.messageCallback(data)
            }

            getMessage(callback) {
                this.messageCallback = callback
            }

            // 检查是否在白名单
            checkedOrigin(origin) {

                for (let i = 0; i < this.origins.length; i++) {
                    if (origin.indexOf(this.origins[i]) > -1) {
                        return true;
                    }
                }
                return false
            }
            // 初始化
            init() {
                srcList = this.Application.srcList || [];

                let appName = this.appName = this.dataset.app;
                this.state = this.checkedSite(appName);

                this.shadow = this.attachShadow({ mode: 'closed' })

                this.showScrollBar = this.getAttribute('showScrollBar')

                this.containerEle = document.createElement('div');
                this.containerEle.classList.add('containerEle')

                this.shadow.appendChild(this.containerEle)
                if (!this.state) {
                    return
                }
                this.src = this.state.url;

                this.styleText = this.getAttribute('style');

                this.style();
                this.createIframe();
                this.Application.elements.push(this)
                this.getMessage = (callback) => {
                    this.messageCallback = callback
                }
            }

            style() {

                const style = document.createElement('style')
                style.textContent =/* css */ `
                    .iframe-content{
                        height:100%;
                        width:calc(100% + 16px);
                        border:none;
                    }
                    .containerEle{
                        overflow:hidden;
                        height:100%;
    
                        ${this.styleText ? this.styleText : ''}
                    }
                `
                this.shadow.appendChild(style)
            }

            createIframe() {
                const iframe = this.iframe = document.createElement('iframe');
                iframe.id = this.uuid;
                iframe.onload = this.iframe_onload.bind(this);
                iframe.onerror = this.onerror
                iframe.src = this.src;
                iframe.classList.add('iframe-content')
                iframe.frameborder = "no";
                iframe.border = 0;

                this.containerEle.appendChild(iframe)

                res(this.iframe)
            }

            checkedSite(id) {
                return srcList.find(item => item.id == id)
            }

            /**
             * 发送消息
             * @param {any} data 
             */
            sendMessage(data) {
                if (!this.iframe) {
                    this.msgQueuing.push(data);
                } else {
                    this.iframe.contentWindow.postMessage(data, '*')
                }
            }

            iframe_onload() {
                this.loaded = true;
                
                if (this.msgQueuing.length) {
                    this.msgQueuing.forEach(item => {
                        this.iframe.contentWindow.postMessage(item, '*')
                    })
                    this.msgQueuing = []
                }
            }
            onerror(err) {
                this.loaded = false;
            }


        }
        customElements.define('view-container', ViewContainer);
    })


}
